import { _ as t } from "../internals/export.js";
import { f as a } from "../internals/fails.js";
import { m as r } from "../internals/math-expm1.js";
var n = Math.abs,
  s = Math.exp,
  i = Math.E;
t({
  target: "Math",
  stat: !0,
  forced: a(function () {
    return -.00000000000000002 != Math.sinh(-.00000000000000002);
  })
}, {
  sinh: function sinh(t) {
    var a = +t;
    return 1 > n(a) ? (r(a) - r(-a)) / 2 : (s(a - 1) - s(-a - 1)) * (i / 2);
  }
});